import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PersonaEffects, personaReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([PersonaEffects]), StoreModule.forFeature(`persona`, personaReducer)]
})
export class PersonaStateModule {}
